module.exports = __webpack_public_path__ + "static/img/7areaA_13.76cd490.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/7areaA_13.png
// module id = 1048
// module chunks = 1